import { IOnePageSections, ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

export function isOnePageSection(section: any): section is IOnePageSections {
  return Object.values(ONE_PAGE_SECTIONS).includes(section);
}
